// extracted by mini-css-extract-plugin
var _1 = "ReportBody__empty--POpeb";
var _2 = "ReportBody__leftArrow--qOKq7";
var _3 = "ReportBody__link--VD9Bp SchoolGeneral__link--tS8wu OfficeGeneral__inlineLink--J2Xk5 OfficeGeneral__inlineLinkBase--ofwQY OfficeGeneral__roboto--WQooW CoreGeneral__roboto--UlmjE";
var _4 = "ReportBody__loading--xuQJd SchoolGeneral__loading--lfV7U";
var _5 = "ReportBody__main--dbg7H";
var _6 = "ReportBody__modalClose--jNE4p";
var _7 = "ReportBody__nav--n1oxo";
var _8 = "ReportBody__navLink--y0QOP";
var _9 = "ReportBody__navOuter--bQ9jb";
var _a = "ReportBody__navText--D2Dan";
var _b = "ReportBody__notice--aOVJQ SchoolGeneral__notice--w1WIt";
var _c = "ReportBody__problemsBackdrop--S6959";
var _d = "ReportBody__problemsBackdropWrapper--uWEvW";
var _e = "ReportBody__problemsModal--FXaLm";
var _f = "ReportBody__reportInner--UeOTz";
var _10 = "ReportBody__reportOuter--UbgMl SchoolGeneral__maxContent--f4Rpz";
var _11 = "ReportBody__rightArrow--Zg6yI";
var _12 = "ReportBody__unassignedMessage--rEyth SchoolGeneral__textOnlyNotice--yqpRc";
export { _1 as "empty", _2 as "leftArrow", _3 as "link", _4 as "loading", _5 as "main", _6 as "modalClose", _7 as "nav", _8 as "navLink", _9 as "navOuter", _a as "navText", _b as "notice", _c as "problemsBackdrop", _d as "problemsBackdropWrapper", _e as "problemsModal", _f as "reportInner", _10 as "reportOuter", _11 as "rightArrow", _12 as "unassignedMessage" }
